import axios from 'axios';
import { API_URL } from 'utils';

export default async function logout() {
  try {
    const response = await axios(`${API_URL}/auth/logout`, {
      withCredentials: true,
    });
    return response;
  } catch (err) {
    console.log(err);
  }
};